/* This file is autogenerated by "pnpm run generateIconComponents" command */
import React from 'react';
import { SVGProps } from 'react';

const ChevronUp: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M12.0001 10.7071 6.7071 16 5.293 14.5858 12 7.8787l6.7071 6.7071L17.293 16z" clipRule="evenodd"/></svg>
);

export default ChevronUp;
